import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SocioEnvironmentalTermsDto } from 'src/app/domain/models/dto/socio-environmental-terms.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocioEnvironmentalService {

  constructor(private http: HttpClient) { }

  get(id: number) {
    return this.http.get<ResponseObjectModel<SocioEnvironmentalTermsDto>>(`${environment.API_BASE_URL}/v1/socioenvironmental-terms/${id}`);
  }
}
